export default {
  name: "VSIPlatformSection",

  data() {
    return ({
      vsi_data: {
        kicker: "Radical Transparency",
        title: "The VSI Platform",
        description:
          "We don’t guess impact — we track it. The Visible Social Impact Platform is the “Amazon” of impact tracking. Every transaction on a cart’s POS system feeds directly into this dashboard, verifying the SSIN value in real-time.",
        cta_text: "Request Dashboard Access",
        cta_link: "#request-dashboard",
      },

      vsi_metrics: [
        { key: "jobs", label: "Jobs Created", value: "1,245" },
        { key: "assets", label: "Active Assets", value: "312" },
      ],

      vsi_chart: {
        label: "Revenue Generation (Monthly)",
        bars: Array.from({ length: 12 }, (_, idx) => ({ key: `m${idx + 1}` })),
      },
    });
  },
};
